import { BroadcastChannel } from 'broadcast-channel';
import { create } from 'zustand';

export type ThemeType = 'dark' | 'light';
export type ThemePreference = 'dark' | 'light';

type ThemeStore = {
  theme: ThemeType;
  preference: ThemePreference;
  setPreference: (pref: ThemePreference) => void;
  /** @deprecated use setPreference instead */
  setTheme: (theme: ThemeType) => void;
  hydrate: () => void;
};

const THEME_CHANNEL = 'theme_change';
let themeChannel: BroadcastChannel<ThemePreference> | null = null;

const getChannel = () => {
  if (typeof window === 'undefined') return null;
  if (!themeChannel) {
    themeChannel = new BroadcastChannel<ThemePreference>(THEME_CHANNEL);
  }
  return themeChannel;
};

export const useThemeStore = create<ThemeStore>((set) => ({
  theme: 'light',
  preference: 'light',
  setPreference: (pref) => {
    if (typeof window !== 'undefined') {
      localStorage.setItem('theme-preference', pref);
    }
    set({ preference: pref, theme: pref });
    getChannel()?.postMessage(pref);
  },
  setTheme: (theme) => {
    if (typeof window !== 'undefined') {
      localStorage.setItem('theme', theme);
      localStorage.setItem('theme-preference', theme);
    }
    set({ theme, preference: theme });
    getChannel()?.postMessage(theme);
  },
  hydrate: () => {
    if (typeof window === 'undefined') return;

    const pref = localStorage.getItem('theme-preference');
    if (pref === 'dark' || pref === 'light') {
      set({ preference: pref, theme: pref });
    } else {
      const legacy = localStorage.getItem('theme');
      if (legacy === 'dark' || legacy === 'light') {
        localStorage.setItem('theme-preference', legacy);
        set({ preference: legacy, theme: legacy });
      } else {
        localStorage.setItem('theme-preference', 'light');
        set({ preference: 'light', theme: 'light' });
      }
    }

    // 다른 탭/페이지에서 테마 변경 시 동기화
    const channel = getChannel();
    if (channel) {
      channel.onmessage = (pref) => {
        if (pref === 'dark' || pref === 'light') {
          set({ preference: pref, theme: pref });
        }
      };
    }
  },
}));
